import React, { useEffect, useState } from 'react'
import Cleave from 'cleave.js/react'
function InputIDCardNumber({ value, onChange, ...other }) {
  const [isValid, setIsValid] = useState(false)
  const options = {
    blocks: [1, 4, 5, 2, 1],
    uppercase: true,
    numericOnly: true
  }
  useEffect(() => {
    const maxLength = 13
    const regex = /^[0-9]\d*$/

    if (!value) return
    const formattValue = value.replace(/ /g, '')
    if (
      formattValue !== undefined &&
      formattValue.toString().length === maxLength &&
      formattValue.match(regex) &&
      validNationalID(formattValue)
    ) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [value])
  const validNationalID = (id) => {
    if (id.length !== 13) return false
    let sum = 0
    for (let i = 0; i < 12; i++) {
      sum += parseInt(id.charAt(i)) * (13 - i)
    }
    let mod = sum % 11
    let check = (11 - mod) % 10
    if (check === parseInt(id.charAt(12))) {
      return true
    }
    return false
  }
  return (
    <Cleave
      className={`form-control ${
        value && !isValid && 'border-danger text-danger'
      }`}
      value={value}
      onChange={onChange}
      options={options}
      id="prefix"
      // isValid={isValid}
      {...other}
    />
  )
}

export default InputIDCardNumber
